import React from 'react';
import { Alert } from 'reactstrap';
import ReportsListRow from './ReportsListRow';
import './ReportListTable.css';

const ReportListTable = ({ reports, onBoxClick,user }) => {
  const sortedReports = [...reports].sort((a, b) => {
    const nameA = (a.reportName || '').trim();
    const nameB = (b.reportName || '').trim();
    const startsWithNumberA = /^\d/.test(nameA);
    const startsWithNumberB = /^\d/.test(nameB);
    if (startsWithNumberA && !startsWithNumberB) return 1;
    if (!startsWithNumberA && startsWithNumberB) return -1;
    return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
  });
  return (
    <div className="table-header-fixed">
      <table className="provisionList reports-table">
        <thead>
          <tr>
            <th className="cursor-pointer report-col">Reports</th>
            <th className="description-col">Description</th>
            <th className="owner-col">Owner</th>
            {user.permissionsGroup !== "Customer" && (
              <th className="cursor-pointer audience-col">Audience</th>
            )}
          </tr>
        </thead>
        <tbody>
        {sortedReports.length ? (
            sortedReports.map((report, i) => (
              <ReportsListRow
                report={report}
                key={i}
                onBoxClick={onBoxClick}
                user={user}
              />
            ))
          ) : (
            <tr>
              <td colSpan={10}>
                <Alert rowSpan={10} color="info">
                  No Reports found.
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReportListTable;
